export default class Environment {
  static isProduction() {
    return this.env() === 'production';
  }

  static isStaging() {
    return this.env() === 'staging';
  }

  static isQa() {
    return this.env() === 'qa';
  }

  static isRunningLocally() {
    return window.location.host.includes('localhost');
  }

  static env() {
    // NODE_ENV is used to generate a production build of React, so if we test a static build in staging,
    // the generated code will still assume the environment is production

    // REACT_APP_ENV provides the environment that the app runs under i.e. production, staging etc.
    return process.env.REACT_APP_ENV;
  }

  static publicDns() {
    return window.location.host.replace(/^www\./, '');
  }
}
